import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Col,
  Row,
  Spinner,
  Badge,
} from "reactstrap";

import {
  resourcesSalidas,
  resourcesBranchGeo,
  postPagoAdministrativo,
  getSalidasCheckEvents,
  getSalidaReport,
  resourcesReports,
  getSalidasDataPath,
  resourcesPapeletas,
} from "../../../helpers/backend_helper";
import { getStorageCompany, getStorageUser } from "../../../helpers/api_helper";
import { Alert, ToastHelper } from "../../../helpers/alerts/alertHelper";
import dayjs from "dayjs";

import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Popup,
  Circle,
  CircleMarker,
  Polyline,
} from "react-leaflet";
import MapReport from "./MapReport";
import { marker } from "leaflet";
import useTour, { Speeds } from "./useTour";
import PreviewPDF from "../../../helpers/previewPDF";
import { PROFILES } from "../../../components/VerticalLayout/SidebarContent";

const DetailModal = ({
  modal,
  setModal,
  authUser,
  setItems,
  items,
  setModalPdf,
  reloadData
}) => {
  const company = getStorageCompany();
  const [modalPapeleta, setModalPapeleta] = useState(false);
  const [mark, setMark] = useState(null);
  const [errors, setErrors] = useState([]);
  const [pathData, setPathData] = useState(null);
  const [data, setData] = useState({ salida: {}, tiempos: [] });
  const [loadings, setLoadings] = useState({
    check: false,
    checkPath: false,
  });
  const [geofencesSalida, setgeoFencesSalida] = useState([]);

  const {
    speed,
    busPoints,
    isPlaying,
    isTourMode,
    tablePanelRef,
    currentBusIndex,
    currentBusPosition,
    tourHandlers,
  } = useTour(pathData?.positions || []);

  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };
  const getSalidaShow = async () => {
    const response = await resourcesSalidas("show", {}, modal.id);
    if (response?.salida) {
      setData(response);
      setgeoFencesSalida([
        ...response.tiempos.map((e) => {
          return e.geofence_number;
        }),
        response?.fulsalida?.branch?.geofence_route?.numero ?? "vacio",
      ]);
    }
  };

  const pagoAdministrativo = async () => {
    const response = await postPagoAdministrativo({
      date: new Date(),
      salida_id: modal.id,
    });
    if (response.status) {
      getSalidaShow();
    }
  };

  const checkSalidaStatus = async () => {
    setLoadings({ ...loadings, check: true });
    try {
      const response = await getSalidasCheckEvents(modal.id);
      await getSalidaShow();
    } catch (err) {
      console.error(err);
    }
    setLoadings({ ...loadings, check: false });
    reloadData();
  };

  const printTicket = async () => {
    let config = {
      params: { salida_id: modal.id },
      headers: {
        Accept: "application/pdf",
      },
      responseType: "blob",
    };
    const ticket = await resourcesReports("show", config, "salidaTicket");
    let nombre = "Archivo";
    var reader = new FileReader();
    reader.readAsDataURL(ticket);
    reader.fileName = nombre[1] || nombre[0];
    reader.onloadend = function (name) {
      name = nombre[0];
      var base64data = reader.result;
      setModalPdf({ show: true, url: base64data });
    };
  };

  const getDataPath = async () => {
    let config = {
      params: {},
    };
    setLoadings({ ...loadings, checkPath: true });
    try {
      const response = await getSalidasDataPath(modal.id, config);
      let baseDistance = null;
      let baseIn = null;
      let baseOut = null;
      let basePasaje = null;
      let hasLdata = false;
      /*
      if (response.positions.length > 0 && 'ldata' in response.positions[0]?.attributes && response.positions[0]?.attributes?.ldata.trim().length > 0) {
        hasLdata = true;
        for (let position of response.positions) {
          try {
            let ldata = position.attributes.ldata.split(',')
            //position.attributes.totalPasaje = Math.floor((Number(ldata[0]) + Number(ldata[1]) + Number(ldata[2]) + Number(ldata[3])) / 2);
            position.attributes.totalPasaje = Math.floor((Number(ldata[0]) + Number(ldata[1]))/2);
          } catch (err) {
            console.error(err);
          }
        }
      }
      */

      for (let position of response.positions) {
        if (baseDistance == null)
          baseDistance = Number(position.attributes.totalDistance);

        if (basePasaje == null)
          basePasaje = Number(position.attributes.totalPasaje);

        if (baseIn == null)
          baseIn = Number(position.attributes.in1) + Number(position.attributes.in2);

        if (baseOut == null)
          baseOut = Number(position.attributes.out1) + Number(position.attributes.out2);

        position.distancia = position?.attributes?.totalDistance
          ? Number(position?.attributes?.totalDistance - baseDistance) / 1000
          : "";

        position.pasaje = Math.round(
          Number(position?.attributes?.totalPasaje) - basePasaje
        );

        position.in = Math.round(
          Number(position.attributes.in1) + Number(position.attributes.in2) - baseIn
        );
        position.out = Math.round(
          Number(position.attributes.out1) + Number(position.attributes.out2) - baseOut
        );
      }

      console.log("basePasaje", basePasaje);
      console.log("baseIn", baseIn);
      console.log("baseOut", baseOut);

      setPathData(response);
    } catch (err) {
      console.error(err);
    }
    setLoadings({ ...loadings, checkPath: false });
  };

  useEffect(() => {
    getSalidaShow();
  }, []);
  const columns = [
    {
      data: data.salida.no,
      name: "Salida",
    },
    {
      data: data.salida.ramal_nombre,
      name: "Ramal",
    },
    {
      data: data.salida.timer,
      name: "Tiempo",
    },
    {
      data:
        data.salida.type == 1
          ? "Completo"
          : data.salida.type == 2
            ? "Solo Ida"
            : data.salida.type == 3
              ? "Solo Regreso"
              : "-",
      name: "Tipo",
    },
    {
      data: data.salida.date ? data.salida.date + " " + data.salida.time : "",
      name: "Fecha/Hora",
    },
    {
      data: data.salida.destination,
      name: "Destino",
    },
    {
      data: data.salida.unit_name,
      name: "Unidad",
    },
    {
      data: data.salida.operator_name,
      name: "Operador",
    },
    {
      data: data.salida.user_name,
      name: "Analista",
    },
    {
      data: data.salida.return
        ? dayjs(data.salida.return.time).format("HH:mm")
        : "-",
      name: "Regreso",
    },
    {
      data: "-",
      name: "Pago de administración",
    },
  ];

  function getEventString(v) {
    switch (v.type) {
      case "geofenceEnter":
        return (
          "Entrada Geocerca" + ("geocerca" in v ? " " + v.geocerca?.name : "")
        );
      case "geofenceExit":
        return (
          "Salida Geocerca" + ("geocerca" in v ? " " + v.geocerca?.name : "")
        );
      case "alarm":
        return (
          "Alarma" + ("alarm" in v.attributes ? " " + v.attributes.alarm : "")
        );
      case "ignitionOff":
        return "Motor apagado";
      case "ignitionOn":
        return "Motor encendido";
      case "deviceMoving":
        return "Evt. movimiento";
      case "deviceStopped":
        return "Evt. detenido";
      case "deviceOverspeed":
        return "Exceso velocidad";
      case "deviceOnline":
        return "En línea";
      case "deviceOffline":
        return "Fuera de línea";
      default:
        return v.type;
    }
  }

  function getMultiEventString(v) {
    let e = "";
    for (let i = 0; i < v.length; i++) {
      if (i > 0) e += " | ";
      e += getEventString(v[i]);
    }
    return e;
  }

  function getPositionString(v) {
    return v.attributes.motion
      ? "en movimento"
      : "detenido" + (v.count > 0 ? " (" + v.count + ")" : "");
  }

  function getTime(f) {
    return f.substring(11, 19);
  }

  const getReportPapeleta = (id, sid, times = false) => {
    let config = {
      params: { type: 1, date: dayjs().format('YYYY-MM-DD'), sid: sid, times: times },
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    };
    resourcesPapeletas("show", config, id).then((response) => {
      let nombre = "Archivo";
      var reader = new FileReader();
      reader.readAsDataURL(response);
      reader.fileName = nombre[1] || nombre[0];
      reader.onloadend = function (name) {
        name = nombre[0];
        var base64data = reader.result;
        setModalPapeleta({ show: true, update: false, url: base64data });
      };
    });
  };

  const user = getStorageUser();

  return (
    <div>
      <Modal isOpen={modal.show} className="modal-dialog modal-xl">
        <ModalHeader className="bg-primary" toggle={handleClose}>
          Detalle {modal.title}
        </ModalHeader>
        <ModalBody>
          <Row className="p-2 pt-0">
            <div
              className="fw-bold text-center p-1"
              style={{ background: "#ccccd5" }}
            >
              GENERALES
            </div>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Salida:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              #{data.salida.no}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Ramal:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.ramal_nombre} (Tiempo {data.salida.timer})
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Tipo Salida:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.type == 1
                ? "Completo"
                : data.salida.type == 2
                  ? "Solo Ida"
                  : data.salida.type == 3
                    ? "Solo Regreso"
                    : "-"}
            </Col>

            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Fecha/Hora salida:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.date
                ? data.salida.date + " " + data.salida.time
                : ""}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Fecha/Hora regreso:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.return
                ? dayjs(data.salida.return.time).format("HH:mm")
                : "-"}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Pago Admin:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              -
            </Col>

            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Unidad:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.unit_name}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Operador:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.operator_name}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-arrow-alt-circle-up"></i> Analista:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {data.salida.user_name}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-bus"></i> Pasajeros (S/B/BLQ):
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {[PROFILES.Checador].includes(user.profile_id) ? '-' : Math.floor(data.salida.pasajeros)}
              {" "}( {[PROFILES.Checador].includes(user.profile_id) ? '-' : Math.floor(data.salida.pasaje_subida ?? 0)} /
              {" "}{[PROFILES.Checador].includes(user.profile_id) ? '-' : Math.floor(data.salida.pasaje_bajada ?? 0)} /
              {" "}{[PROFILES.Checador].includes(user.profile_id) ? '-' : Math.floor(data.salida.pasaje_bloqueos ?? 0)} )
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-ticket-alt"></i> Tickets Tipo:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              Adulto: {(data.salida.start_ticket ?? 0) && (data.salida.end_ticket ?? 0) ? data.salida.end_ticket - data.salida.start_ticket : '-'}<br />
              Menores: {(data.salida.start_ticket_menor ?? 0) && (data.salida.end_ticket_menor ?? 0) ? data.salida.end_ticket_menor - data.salida.start_ticket_menor : '-'}
            </Col>
            <Col className="bg-light fw-bold p-1" md={2} xs={6}>
              <i className="fa fa-ticket-alt"></i> Tickets totales:
            </Col>
            <Col className="p-1" md={2} xs={6}>
              {
                ((data.salida.start_ticket ?? 0) && (data.salida.end_ticket ?? 0) ? data.salida.end_ticket - data.salida.start_ticket : 0) +
                ((data.salida.start_ticket_menor ?? 0) && (data.salida.end_ticket_menor ?? 0) ? data.salida.end_ticket_menor - data.salida.start_ticket_menor : 0)
              }
            </Col>
          </Row>

          <Row className="mb-1">
            <Col md={12} className="print-hide text-end">
              <button
                className="btn btn-primary btn-sm me-2 mb-2"
                onClick={() => getReportPapeleta(data.salida.unit_id, data.salida.id)}
              >
                <i className="fa fa-print"></i> Imprimir Salida
              </button>

              <button
                className="btn btn-primary btn-sm me-2 mb-2"
                onClick={() => getReportPapeleta(data.salida.unit_id, data.salida.id, true)}
              >
                <i className="fa fa-print"></i> Imprimir Tiempos
              </button>

              <button
                className="btn btn-primary btn-sm me-2 mb-2"
                onClick={printTicket}
              >
                <i className="fa fa-print"></i> Imprimir Ticket
              </button>

              <button
                className="btn btn-primary btn-sm me-2 mb-2"
                onClick={checkSalidaStatus}
                disabled={loadings["check"]}
              >
                {loadings["check"] && <Spinner size="sm"></Spinner>}{" "}
                <i className="fa fa-search"></i> Buscar Tiempos
              </button>

              <button
                className="btn btn-primary btn-sm me-2 mb-2"
                onClick={getDataPath}
                disabled={loadings["checkPath"]}
              >
                {loadings["checkPath"] && <Spinner size="sm"></Spinner>}{" "}
                <i className="fa fa-eye"></i> Ver Recorrido
              </button>

              {!data.salida.pago?.status && (
                <button
                  className="btn btn-primary btn-sm me-2 mb-2"
                  onClick={() => pagoAdministrativo()}
                >
                  <i className="fa fa-coins"></i> Pago Administrativo
                </button>
              )}
            </Col>
          </Row>
          <div className="row">
            <div className="col-sm-12">
              <div className="table-responsive">
                <Table className="table table-sm">
                  <tbody style={{ textAlign: "center" }}>
                    <tr style={{ background: "#ccccd5" }}>
                      <th colSpan={data.tiempos.length}>BITÁCORA</th>
                    </tr>
                    <tr className="bg-light">
                      {data.tiempos.map((tiempo, index) => (
                        <th key={index}>
                          <div title={tiempo.geofence_name}>
                            <small title="">
                              {(tiempo.geofence_alias
                                ? tiempo.geofence_alias
                                : tiempo.geofence_name
                              ).toUpperCase()}
                            </small>
                          </div>
                        </th>
                      ))}
                    </tr>
                    <tr style={{ align: "center" }}>
                      {data.tiempos.map((tiempo, index) => (
                        <td key={index}>
                          {tiempo.tiempo_propuesto}
                        </td>
                      ))}
                    </tr>
                    <tr className="bg-light">
                      <th colSpan={data.tiempos.length}>
                        <small>TIEMPO REAL</small>
                      </th>
                    </tr>
                    <tr>
                      {data.tiempos.map((tiempo, index) => (
                        <td key={index}>
                          {tiempo.tiempo_real
                            ? tiempo.tiempo_real
                            : "Sin Dato"}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <th className="bg-light" colSpan={data.tiempos.length}>
                        <small>DIFERENCIA</small>
                      </th>
                    </tr>
                    <tr style={{ align: "center" }}>
                      {data.tiempos.map((tiempo, index) => (
                        <td key={index}>{tiempo.diferencia ?? "-"}</td>
                      ))}
                    </tr>
                    <tr>
                      <th className="bg-light" colSpan={data.tiempos.length}>
                        <small>QUEMADAS</small>
                      </th>
                    </tr>
                    <tr style={{ align: "center" }}>
                      {data.tiempos.map((tiempo, index) => (
                        <td key={index}>
                          {tiempo.tiempo_real ? (
                            tiempo.quemadas > 0 ? (
                              <i className="fa fa-times text-danger"></i>
                            ) : (
                              <i className="fa fa-check text-success"></i>
                            )
                          ) : (
                            "-"
                          )}
                        </td>
                      ))}
                    </tr>
                    {![PROFILES.Checador].includes(user.profile_id) &&
                      <>
                        <tr>
                          <th className="bg-light" colSpan={data.tiempos.length}>
                            <small>ESTANCIA / SUBIDAS / BAJADAS</small>
                          </th>
                        </tr>
                        <tr style={{ align: "center" }}>
                          {data.tiempos.map((tiempo, index) => (
                            <td key={index}>
                              {index == data.tiempos.length - 1 ?
                                <>
                                  <br />
                                  {data.salida?.pasaje_subida ?? 0} / {data.salida?.pasaje_bajada ?? 0}
                                </>
                                :
                                <>
                                  {tiempo.tiempo_salida ?? '-'} <br />
                                  {data.salida?.pasaje_subida_inicial != null && data.salida?.pasaje_bajada_inicial != null &&
                                    <>
                                      {tiempo.pasaje_in ? (tiempo.pasaje_in - data.salida?.pasaje_subida_inicial > 0 ? tiempo.pasaje_in - data.salida?.pasaje_subida_inicial : 0) : '-'} / 
                                      {tiempo.pasaje_out ? (tiempo.pasaje_out - data.salida?.pasaje_bajada_inicial > 0 ? tiempo.pasaje_out - data.salida?.pasaje_bajada_inicial : 0) : '-'}
                                    </>
                                  }
                                </>
                              }
                            </td>
                          ))}
                        </tr>
                      </>
                    }
                    <tr>
                      <th className="bg-light" colSpan={data.tiempos.length}>
                        <small>EVENTOS:</small>
                      </th>
                    </tr>
                    <tr style={{ align: "center" }}>
                      {data.tiempos.map((tiempo, index) => (
                        <td key={index}>
                          {tiempo.excesos.map((exceso) => (
                            <>
                              <Badge color="warning" className="d-block">
                                Exceso Vel.
                              </Badge>
                              <small>
                                {exceso?.fecha
                                  ? dayjs(exceso.fecha).format("HH:mm")
                                  : ""}
                                <span className="d-block">
                                  <strong>{exceso?.kilometros}km/h</strong>
                                </span>
                              </small>
                            </>
                          ))}
                          {tiempo.salidas_ruta.map((salida) => (
                            <>
                              <Badge color="danger" className="d-block">
                                Salida Ruta
                              </Badge>
                              <small>
                                {salida?.fecha
                                  ? dayjs(salida.fecha).format("HH:mm")
                                  : ""}
                              </small>
                            </>
                          ))}
                          {tiempo.excesos.length == 0 && tiempo.salidas_ruta.length == 0 && "-"}
                        </td>
                      ))}
                    </tr>
                    {/* <tr>
                      <td colSpan={data.tiempos.length}>-</td>
                    </tr> */}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          {pathData && (
            <Row>
              <Col md={6}>
                <div
                  className="text-center p-1"
                  style={{ background: "#ccccd5" }}
                >
                  <b>DETALLE DE POSICIONES</b>
                </div>

                <div
                  className="table-responsive"
                  style={{ maxHeight: "400px", minHeight: "400px" }}
                  ref={tablePanelRef}
                >
                  <Table className="table table-sm table-yellow-hover">
                    <thead>
                      <tr style={{ background: "#ccccd5" }}>
                        <th>#</th>
                        <th>Estado</th>
                        <th>Tiempo</th>
                        <th style={{ minWidth: "90px" }}>Datos</th>
                        <th style={{ minWidth: "100px" }}>Ubicación</th>
                        <th>Pasaje</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pathData.positions.map((item, index) => (
                        <tr
                          key={index}
                          onClick={() => {
                            if (item.latitude && item.longitude)
                              setMark([item.latitude, item.longitude]);
                          }}
                          className={`point-${index} ${isTourMode && index === currentBusIndex
                            ? "table-primary"
                            : ""
                            }`}
                        >
                          <td>
                            <small>{index + 1}</small>
                          </td>
                          <td>
                            <small>
                              {item.type
                                ? getEventString(item)
                                : item.event?.length > 0
                                  ? getMultiEventString(item.event)
                                  : getPositionString(item)}
                            </small>
                          </td>
                          <td>
                            <small>
                              {item?.servertime ? getTime(item.fixtime) : "-"}
                            </small>
                          </td>
                          <td style={{ lineHeight: "0.8em" }}>
                            <small>
                              Vel.{" "}
                              {item?.speed
                                ? (item?.speed * 1.852).toFixed(2) + "km"
                                : "-"}
                              <br />
                              Dst.{" "}
                              {item?.distancia
                                ? (item?.distancia).toFixed(2) + "km"
                                : "-"}
                              <br />
                            </small>
                          </td>
                          <td style={{ lineHeight: "0.8em" }}>
                            <u>
                              <a
                                className="text-underline"
                                target="_blank"
                                rel="noreferrer"
                                href={`https://www.google.com/maps/search/?api=1&query=${item.latitude}%2C${item.longitude}`}
                              >
                                <small>
                                  Lat. {item?.latitude?.toFixed(6)}
                                  <br />
                                  Lng. {item?.longitude?.toFixed(6)}
                                  <br />
                                </small>
                              </a>
                            </u>
                          </td>
                          <td
                            className="text-center"
                            style={{ lineHeight: "0.8em" }}
                          >
                            <small>S: {item.in ?? "-"}</small><br />
                            <small>B: {item.out ?? "-"}</small><br />
                            <small>T: {item.pasaje ?? "-"}</small>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col md={6}>
                <div
                  className="text-center p-1"
                  style={{ background: "#ccccd5" }}
                >
                  <b>MAPA</b>
                </div>
                <div className="row p-2">
                  {pathData.positions.length ? (
                    <>
                      <Col md={6} className="text-center">
                        <small>
                          <span className="me-2">
                            Vel.{" "}
                            {pathData.positions[currentBusIndex]?.speed
                              ? (
                                pathData.positions[currentBusIndex]?.speed *
                                1.852
                              ).toFixed(2) + "km"
                              : "-"}
                          </span>
                          <span className="me-2">
                            Dst.{" "}
                            {pathData.positions[currentBusIndex]?.distancia
                              ? (pathData.positions[
                                currentBusIndex
                              ]?.distancia).toFixed(2) + "km"
                              : "-"}
                          </span>
                          <span className="">
                            Psj.{" "}
                            {pathData.positions[currentBusIndex]?.pasaje
                              ? pathData.positions[currentBusIndex]?.pasaje
                              : "-"}
                          </span>
                        </small>
                      </Col>
                      <Col md={6}>
                        <div className="text-center">
                          <button
                            onClick={() => {
                              tourHandlers.handlePlay();
                            }}
                            disabled={isPlaying}
                            type="button"
                            className="btn btn-sm btn-primary waves-effect waves-light me-2"
                            title="Iniciar recorrido"
                          >
                            <i className="fa fa-play font-size-10 align-middle"></i>
                          </button>
                          <button
                            onClick={tourHandlers.handlePause}
                            disabled={!isPlaying}
                            type="button"
                            className="btn btn-sm btn-primary waves-effect waves-light me-2"
                            title="Pausar recorrido"
                          >
                            <i className="fa fa-pause font-size-10 align-middle"></i>
                          </button>
                          <button
                            onClick={tourHandlers.handleStop}
                            type="button"
                            className="btn btn-sm btn-primary waves-effect waves-light me-4"
                            title="Detener recorrido"
                          >
                            <i className="fa fa-stop font-size-10 align-middle"></i>
                          </button>
                          <button
                            onClick={() =>
                              tourHandlers.handleSpeedChange(Speeds.x1)
                            }
                            type="button"
                            className={`btn btn-sm ${speed === Speeds.x1
                              ? "btn-primary"
                              : "btn-soft-primary"
                              } waves-effect waves-light me-2`}
                          >
                            x1
                          </button>
                          <button
                            onClick={() =>
                              tourHandlers.handleSpeedChange(Speeds.x2)
                            }
                            type="button"
                            className={`btn btn-sm ${speed === Speeds.x2
                              ? "btn-primary"
                              : "btn-soft-primary"
                              } waves-effect waves-light me-2`}
                          >
                            x2
                          </button>
                          <button
                            onClick={() =>
                              tourHandlers.handleSpeedChange(Speeds.x3)
                            }
                            type="button"
                            className={`btn btn-sm ${speed === Speeds.x3
                              ? "btn-primary"
                              : "btn-soft-primary"
                              } waves-effect waves-light`}
                          >
                            x3
                          </button>
                        </div>
                      </Col>
                    </>
                  ) : null}
                </div>

                <MapContainer
                  center={[19.432608, -99.133209]}
                  zoom={13}
                  scrollWheelZoom={false}
                >
                  <TileLayer
                    attribution=""
                    url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                  />
                  <MapReport
                    positions={pathData.positions}
                    geofences={pathData.geocercas.filter((e) => {
                      return geofencesSalida.includes(parseInt(e.numero));
                    })}
                    marker={isTourMode ? currentBusPosition : mark}
                  />
                  <Polyline positions={busPoints} color="blue" weight={5} />
                </MapContainer>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {modalPapeleta.show && (
        <PreviewPDF modalPdf={modalPapeleta} setModalPdf={setModalPapeleta} />
      )}
    </div>
  );
};

export default DetailModal;
